export default function getSortedLeaseTerms(sortedLeaseTerms, sort_offer_by) {
  switch (sort_offer_by) {
    case 'LEASE_LENGTH_LONGEST':
      sortedLeaseTerms.sort((a,b) =>{
        let _a = a.lease_term_name.split(" ")[0]
        let _b = b.lease_term_name.split(" ")[0]
        if (isNaN(_a) && isNaN(_b)) return ( _b.localeCompare(_a))
        return _b - _a
      })
      break
    case 'LEASE_LENGTH_SHORTEST':
      sortedLeaseTerms.sort((a,b) =>{
        let _a = a.lease_term_name.split(" ")[0]
        let _b = b.lease_term_name.split(" ")[0]
        if (isNaN(_a) && isNaN(_b)) return ( _a.localeCompare(_b))
        return _a - _b
      })
      break
    case 'RENEWAL_RENT_LONGEST':
      sortedLeaseTerms.sort((a, b) => b.new_total - a.new_total)
      break
    case 'RENEWAL_RENT_SHORTEST':
      sortedLeaseTerms.sort((a, b) => a.new_total - b.new_total)
      break
    default:
      break
  }
  return sortedLeaseTerms
}